import { Vue, i18n } from 'Common/vue';

// import components
import Autocomplete from 'VueComponents/Autocomplete.vue';
import Minicart from 'VueComponents/Minicart.vue';

import 'Ui/toggle';
import './navigation';

if (document.querySelector('#autocomplete')) {
    window.$_autocomplete = new Vue({
        i18n,
        render: h => h(Autocomplete)
    }).$mount("#autocomplete");
}

if (document.querySelector('#minicart')) {
    window.$_minicart = new Vue({
        i18n,
        render: h => h(Minicart)
    }).$mount("#minicart");
}

if (document.querySelector('.js-trigger-search')) {
    document.querySelector('.js-trigger-search').addEventListener('click', event => {
        event.preventDefault();

        rEvent.dispatch("Autocomplete.showForm");
    });
}
